import { getColumnDynamicsState, getCustomColDefProperties, type ColumnDynamics } from '@talos/kyoko';
import type { ICellRendererParams } from 'ag-grid-community';
import type { MarketSelectorValue } from '../../../../MarketSelector/types';
import type { PriceGridEntity } from '../../../PriceGridEntity';
import type { PriceGridMarketDataColumnSettings } from '../../dynamics/types';

type PriceGridMarketDataColumnDynamicsSettings = PriceGridMarketDataColumnSettings;

function getPriceGridColumnDynamics(params: Pick<ICellRendererParams<PriceGridEntity>, 'colDef'>) {
  return (
    getCustomColDefProperties(params.colDef)?.dynamics ??
    (params.colDef as { dynamics?: ColumnDynamics<PriceGridMarketDataColumnDynamicsSettings> }).dynamics
  );
}

export function getPriceGridColumnMarketSelectorValue(
  params: Pick<ICellRendererParams<PriceGridEntity>, 'colDef'>
): MarketSelectorValue | undefined {
  const dynamics = getPriceGridColumnDynamics(params);
  if (!dynamics) {
    return undefined;
  }

  return getColumnDynamicsState<PriceGridMarketDataColumnDynamicsSettings>(dynamics)?.marketSelectorValue;
}
